var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Admin Page")])]),_c('v-spacer'),_c('router-link',{attrs:{"to":{ name: 'Admin-Dashboard' }}},[_c('v-btn',[_vm._v("Dashboard")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }